const isFullNameValid = (name) => {
  const regEx = /^\S{2,}(\s\S{2,})+$/
  return regEx.test(name.trim())
}
export default isFullNameValid
